module.exports = __webpack_public_path__ + "img/snippin-dark.1dc95cff.svg";